import { MdLaunch } from 'react-icons/md';

import { FontSize } from 'commons';
import {
  Accordion,
  Button,
  Collect,
  DashboardHistoryAndTracking,
  FabSupport,
  Text,
} from 'components';
import { ConsignmentDetails, PointOfSaleType } from 'types';

import { PrintLabel } from '../components';
import * as S from './styles';

interface Props {
  consignment: ConsignmentDetails;
  defaultOpen?: boolean;
}

export function StepTransport({ consignment, defaultOpen = true }: Props) {
  const {
    lastRegistration,
    code: consignmentCode,
    pointOfSale,
    nfeLink,
  } = consignment;
  const isCollected = Boolean(lastRegistration.carrier);
  const isPointOfSaleAutomatic = pointOfSale.type === PointOfSaleType.Automatic;
  const accordionTitle = `Impressão de etiqueta ${
    isPointOfSaleAutomatic ? ' e nota/cupom fiscal' : ''
  }`;

  return (
    <S.Main>
      <Collect consignment={consignment} defaultOpen={defaultOpen} />
      <div className="hidden tablet:block">
        <Accordion title={accordionTitle} defaultOpen={defaultOpen}>
          <S.PrintLabelWrapper>
            {isPointOfSaleAutomatic && (
              <S.Wrapper>
                <S.ButtonWrapper>
                  <Text size={FontSize.font12}>
                    <strong>Nota fiscal emitida!</strong> Para salvar ou
                    imprimir a nota fiscal acesse:
                  </Text>

                  <S.Anchor href={nfeLink} target="_blank" tabIndex={-1}>
                    <Button variant="secondary">
                      <MdLaunch /> Acessar Nota Fiscal
                    </Button>
                  </S.Anchor>
                </S.ButtonWrapper>
              </S.Wrapper>
            )}

            <PrintLabel consignment={consignment} />
          </S.PrintLabelWrapper>
        </Accordion>
      </div>
      <DashboardHistoryAndTracking
        consignmentCode={consignmentCode}
        showDeliveryFail={isCollected}
        defaultOpen={isCollected || !defaultOpen}
      />
      <FabSupport
        consignmentCode={consignmentCode}
        showDeliveryFail={isCollected}
      />
    </S.Main>
  );
}
